import e from"react";import t from"../utils/styled.js";import{Spinner as r}from"@blueprintjs/core";import{t as o}from"../utils/l10n.js";import{registerNextDomDrop as l}from"../canvas/page.js";import{mobileStyle as n}from"../utils/screen.js";const i=t("div",e.forwardRef)`
  height: 100%;
  overflow: auto;
`,a=t("div")`
  width: 33%;
  float: left;
`,s=t("div")`
  padding: 5px;
  width: 100%;
  &:hover .credit {
    opacity: 1;
  }
  ${n("\n    .credit {\n      opacity: 1;\n    }\n  ")}
`,c=t("div")`
  border-radius: 5px;
  position: relative;
  overflow: hidden;
  box-shadow: ${e=>e["data-shadowenabled"]?"0 0 5px rgba(16, 22, 26, 0.3)":""};
`,d=t("img")`
  width: 100%;
  cursor: pointer;
  display: block;
  max-height: 300px;
  min-height: 50px;
  object-fit: contain;
`,g=t("div")`
  position: absolute;
  bottom: 0px;
  left: 0px;
  font-size: 10px;
  padding: 3px;
  padding-top: 10px;
  text-align: center;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.4),
    rgba(0, 0, 0, 0.6)
  );
  width: 100%;
  opacity: 0;
  color: white;
`,m=t("p")`
  text-align: center;
  padding: 30px;
`,u=({url:t,credit:r,onSelect:o,crossOrigin:n,shadowEnabled:i,itemHeight:a,className:m,onLoad:u})=>{const p=null==i||i;return e.createElement(s,{onClick:()=>{o()},className:"polotno-close-panel"},e.createElement(c,{"data-shadowenabled":p},e.createElement(d,{className:m,style:{height:null!=a?a:"auto"},src:t,draggable:!0,loading:"lazy",crossOrigin:n,onDragStart:()=>{l(({x:e,y:t},r,l)=>{o({x:e,y:t},r,l)})},onDragEnd:()=>{l(null)},onLoad:u}),r&&e.createElement(g,{className:"credit"},r)))};export const ImagesGrid=({images:t,onSelect:l,isLoading:n,getPreview:s,loadMore:c,getCredit:d,getImageClassName:g,rowsNumber:p,crossOrigin:h="anonymous",shadowEnabled:f,itemHeight:v,error:w,hideNoResults:b=!1})=>{const x=p||2,y=e.useRef(null),E=[];for(var N=0;N<x;N++){E.push((t||[]).filter((e,t)=>t%x===N))}const H=e.useRef(null),j=()=>{var e,r,o;const l=(null===(e=y.current)||void 0===e?void 0:e.scrollHeight)>(null===(r=y.current)||void 0===r?void 0:r.offsetHeight)+5,i=t&&t.length,a=Array.from(null===(o=y.current)||void 0===o?void 0:o.querySelectorAll("img")).every(e=>e.complete);!l&&c&&!n&&i&&a&&(H.current||(H.current=window.setTimeout(()=>{H.current=null,c&&c()},100)))},S=()=>{j()};return e.useEffect(()=>(j(),()=>{window.clearTimeout(H.current),H.current=null}),[t&&t.length,n]),e.createElement(i,{onScroll:e=>{const t=e.target.scrollHeight-e.target.scrollTop-e.target.offsetHeight;c&&!n&&t<200&&c()},ref:y},E.map((t,o)=>e.createElement(a,{key:o,style:{width:100/x+"%"}},t.map((t,r)=>e.createElement(u,{url:s(t),onSelect:(e,r,o)=>l(t,e,r,o),key:r,credit:d&&d(t),crossOrigin:h,shadowEnabled:f,itemHeight:v,className:g&&g(t),onLoad:S})),n&&e.createElement("div",{style:{padding:"30px"}},e.createElement(r,null)))),!n&&(!t||!t.length)&&!w&&!b&&e.createElement(m,null,o("sidePanel.noResults")),w&&e.createElement(m,null,o("sidePanel.error")))};